import { useState } from "react";
import { Box, Button, CircularProgress, Grid2 } from "@mui/material";
import { useAppDispatch } from "../../../stores/store";
import { updateIncorpartion } from "../../../stores/incorporation";
import { StyledContainer } from "../../style/ititn/DeatilStyle";
import {
  StyledButtonContainer,
  StyledHeader,
  StyledLink,
  StyledUploadSection,
} from "../../style/ititn/itinUpload";
import UploadFileField from "../../common-components/UploadFileField";
import { UploadIcon } from "../../../assets/Icon/dashboredIcon";
import CustomModal from "../../common-components/CustomModal";
import { setToast } from "../../../stores/toast/toastslice";
import { useNavigate, useParams } from "react-router";
import * as Yup from "yup";
import { ErrorMessage, Formik, Form } from "formik";

// Define interface for form values
interface FormValues {
  signed_ein_form: File | null;
}
const data = [
  {
    title: "When signing SS4  form, please follow:",
    heading:
      "You should find your full name at the bottom of the page. Please sign below your full name.",
    instructions: [
      "Sign with BLUE PEN, fill the Date in US Format (mm-dd-yyyy)",
      "Your signature must match with the signature on your passport.",
    ],
  },
];

interface StepProp {
  existingFiles?: { signed_ein_form?: string };
  formTitle: string;
  formTitle2?: string;
  id?: string;
  uploadedFile?: File | string | null;
  edit?: boolean;
  onCancelEdit?: () => void; 
  onSuccess?:()=>void;
}

const UploadSignComponent = (props: StepProp) => {
  const { existingFiles, formTitle, uploadedFile ,edit,onCancelEdit,onSuccess } = props;
  const dispatch = useAppDispatch();
  const [isSignModalOpen, setIsSignModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleModalOpen = () => setIsSignModalOpen(true);
  const handleModalClose = () => setIsSignModalOpen(false);



  const validationSchema = Yup.object().shape({
    signed_ein_form: Yup.mixed()
      .nullable()
      .test(
        "is-required-or-not",
        "SS4 signature form is required",
        function (value) {
          const { edit, uploadedFile } = props;
         
          if (!edit) return !!value;
         
          return !!value || !!uploadedFile;
        }
      )
      .test(
        "fileSize",
        "File size too large (max 5MB)",
        function (value) {
          if (!value || typeof value === "string") return true; 
          if (value instanceof File) {
            return value.size <= 5 * 1024 * 1024;
          }
          return false;
        }
      )
      
  });
  

  const handleFileChange = (
    file: File | null,
    key: keyof FormValues,
    setFieldValue: (field: keyof FormValues, value: File | null) => void
  ) => {
    setFieldValue(key, file);
  };

  const handleSubmit = async (values: FormValues) => {
    setLoading(true);

    try {
      const formData = new FormData();
      const einFileSigned =
        values.signed_ein_form && typeof values.signed_ein_form !== "string";

      if (!einFileSigned) {
        if (edit && onCancelEdit) {
          onCancelEdit(); // 👈 Reset edit mode in parent
        }
        // setLoading(false);
        return;
      }
      if (
        values.signed_ein_form &&
        typeof values.signed_ein_form !== "string"
      ) {
        formData.append("signed_ein_form", values.signed_ein_form);
      } else {
        throw new Error("No file selected.");
      }

      if (props.id) {
        formData.append("incorporation_id", props.id);
      }
      const response = await dispatch<any>(updateIncorpartion(formData)).unwrap();

      if (response?.status === 1) {
        setLoading(false);
        dispatch<any>(
          setToast({
            message: response.message || "Form submitted successfully!",
            type: "success",
            title: "Success",
          })
        );
        // if (onSuccess) {

        //   onSuccess();
        // }
        setTimeout(() => {
          window.location.reload();
        }, 30);
      } else {
        throw new Error(response?.message || "Something went wrong!");
      }
    } catch (error: any) {
      setLoading(false);
      dispatch<any>(
        setToast({
          message: error.message || "Submission failed. Please try again.",
          type: "error",
          title: "Error",
        })
      );
    }
  };

  return (
    <Formik<FormValues>
      initialValues={{ signed_ein_form: null }}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
    >
      {({ setFieldValue, errors, touched }) => (
        <Form>
          <StyledContainer>
            <StyledHeader>
              Upload Signed Form
              <StyledLink to="" onClick={handleModalOpen}>
                Read Signature Instruction
              </StyledLink>
            </StyledHeader>
            <Box sx={{ height: "1px", background: "#EAF1FA" }}></Box>
       
            <Grid2 container spacing={2} alignItems="center">
              <Grid2 size={{ xs: 12, sm: 6, md: 6, lg: 4 }}>
                <Box>
                  <UploadFileField
                    title={formTitle}
                    accept="application/pdf, image/jpeg, image/jpg,image/png"
                    desc="Click here or drag & drop"
                    icon={<UploadIcon />}
                    onChange={(file) =>
                      handleFileChange(file, "signed_ein_form", setFieldValue)
                    }
                    fileUrl={uploadedFile}
                  />
                  <Box
                    sx={{
                      color: "#D32F2F",
                      fontSize: "16px",
                      fontWeight: 400,
                      margin: "6px",
                      marginLeft: "12px",
                    }}
                  >
                    <ErrorMessage name="signed_ein_form" component="div" />
                  </Box>
                </Box>
              </Grid2>
            </Grid2>
            <StyledButtonContainer>
              <Button
                variant="contained"
                sx={{
                  minWidth: "191px",
                  height: "52px",
                  fontSize: "16px",
                  borderRadius: "8px",
                  fontWeight: 600,
                  background: loading
                    ? "#D3D3D3"
                    : "linear-gradient(98.24deg, #2977CC 4.13%, #1D538F 128.24%)",
                  color: "#FFFFFF",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
                type="submit"
                disabled={loading}
              >
                {loading ? (
                  <CircularProgress
                    size={24}
                    sx={{
                      "& svg": {
                        stroke: "url(#gradientColor)",
                      },
                    }}
                  />
                ) : (
                  "Submit"
                )}
              </Button>
            </StyledButtonContainer>
            <CustomModal
              open={isSignModalOpen}
              handleClose={handleModalClose}
              title="Application Signature Instruction"
              data={data}
              // desc="After signing please scan and email us."
              isSs4
            />
          </StyledContainer>
        </Form>
      )}
    </Formik>
  );
};

export default UploadSignComponent;
